import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { memo } from "react";
import { useGeneralLibraryTitle } from "~/components/LibraryBeta/hooks/useGeneralLibraryTitle";
import { usePrivateAddOnFeatures } from "~/hooks/usePrivateAddOnFeatures";
import { useCurrentWorkspace } from "~/providers/CurrentWorkspaceProvider";
export const PrivateGalleryBoardAncestors = /*#__PURE__*/ memo((param)=>{
    let { libraryTitle, ancestors } = param;
    const { libraries: librariesFlag } = usePrivateAddOnFeatures();
    const { currentWorkspace } = useCurrentWorkspace();
    const { generalLibraryTitle } = useGeneralLibraryTitle();
    if (!(ancestors === null || ancestors === void 0 ? void 0 : ancestors.length)) {
        if (librariesFlag) {
            return /*#__PURE__*/ _jsx(_Fragment, {
                children: libraryTitle !== null && libraryTitle !== void 0 ? libraryTitle : generalLibraryTitle
            });
        } else {
            return /*#__PURE__*/ _jsx(_Fragment, {
                children: currentWorkspace === null || currentWorkspace === void 0 ? void 0 : currentWorkspace.name
            });
        }
    }
    const nearestAncestorTitle = ancestors[ancestors.length - 1].title;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: ancestors.length > 1 ? "\xb7\xb7\xb7 / ".concat(nearestAncestorTitle) : nearestAncestorTitle
    });
});
PrivateGalleryBoardAncestors.displayName = "PrivateGalleryBoardAncestors";
